(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gvm-configurator2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGvmConfigurator(root) {
      var configScripts = root.querySelectorAll('[data-gvm-config]');
      var configs = [];
      configScripts.forEach(function (el) {
        try {
          configs.push(JSON.parse(el.textContent));
        } catch (e) {
          configs.push(null);
        }
      });

      var tabButtons = root.querySelectorAll('[data-gvm-tab-btn]');
      var els = {
        image: root.querySelector('[data-gvm-image]'),
        weight: root.querySelector('[data-gvm-weight]'),
        liftBadge: root.querySelector('[data-gvm-lift-badge]'),
        installBadge: root.querySelector('[data-gvm-install-badge]'),
        vehicleText: root.querySelector('[data-gvm-vehicle-text]'),
        preRego: root.querySelector('[data-gvm-pre-rego]'),
        postRego: root.querySelector('[data-gvm-post-rego]'),
        description: root.querySelector('[data-gvm-description]'),
        kitList: root.querySelector('[data-gvm-kit-list]'),
        sku: root.querySelector('[data-gvm-sku]'),
        summary: root.querySelector('[data-gvm-summary]'),
        price: root.querySelector('[data-gvm-price]'),
        enquire: root.querySelector('[data-gvm-enquire]')
      };

      var groupNames = ['shocks', 'ucas', 'leafs', 'airbags'];
      var singleSelectGroups = { shocks: true, leafs: true };

      var currentConfig = null;
      var state = {}; // { shocks: index|null, ucas: index|null, leafs: index|null, airbags: index|null }

      function formatPrice(n) {
        return '$' + Math.round(n).toLocaleString('en-AU');
      }

      function optionAt(groupName, index) {
        if (!currentConfig || index === null || index === undefined) return null;
        var list = currentConfig[groupName] || [];
        return list[index] || null;
      }

      function computeSku() {
        if (!currentConfig) return '';
        var parts = [currentConfig.sku_prefix || ''];
        var leaf = optionAt('leafs', state.leafs);
        var shock = optionAt('shocks', state.shocks);
        var uca = optionAt('ucas', state.ucas);
        var airbag = optionAt('airbags', state.airbags);
        if (leaf && leaf.sku_code) parts.push(leaf.sku_code);
        if (shock && shock.sku_code) parts.push(shock.sku_code);
        if (uca && uca.sku_code) parts.push(uca.sku_code);
        if (airbag && airbag.sku_code) parts.push(airbag.sku_code);
        return parts.join('-');
      }

      function computePrice() {
        if (!currentConfig) return 0;
        var total = currentConfig.base_price || 0;
        groupNames.forEach(function (g) {
          var opt = optionAt(g, state[g]);
          if (opt && typeof opt.price_delta === 'number') total += opt.price_delta;
        });
        return total;
      }

      function renderOptions(groupName) {
        var wrap = root.querySelector('[data-gvm-options="' + groupName + '"]');
        var selectedLabelEl = root.querySelector('[data-gvm-selected="' + groupName + '"]');
        if (!wrap || !currentConfig) return;
        var list = currentConfig[groupName] || [];
        wrap.innerHTML = '';

        if (list.length === 0) {
          wrap.parentElement.style.display = 'none';
          return;
        }
        wrap.parentElement.style.display = '';

        list.forEach(function (opt, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'gvm-cfg__option-pill';
          btn.setAttribute('data-recommended', opt.recommended ? 'true' : 'false');
          btn.setAttribute('data-group', groupName);
          btn.setAttribute('data-index', i);
          var labelHtml = opt.label || '';
          if (opt.recommended) labelHtml += '<small>Recommended</small>';
          btn.innerHTML = labelHtml;
          if (state[groupName] === i) btn.classList.add('is-selected');
          btn.addEventListener('click', function () {
            if (singleSelectGroups[groupName]) {
              state[groupName] = i;
            } else {
              // optional toggle group (ucas / airbags)
              state[groupName] = state[groupName] === i ? null : i;
            }
            render();
          });
          wrap.appendChild(btn);
        });

        var selectedOpt = optionAt(groupName, state[groupName]);
        if (selectedLabelEl) selectedLabelEl.textContent = selectedOpt ? selectedOpt.label : '—';
      }

      function renderKitContents() {
        if (!els.kitList || !currentConfig) return;
        var items = (currentConfig.kit_contents || []).slice();
        var uca = optionAt('ucas', state.ucas);
        var airbag = optionAt('airbags', state.airbags);
        if (uca && uca.label && items.indexOf(uca.label) === -1) items.push(uca.label);
        if (airbag && airbag.label && items.indexOf(airbag.label) === -1) items.push(airbag.label);
        els.kitList.innerHTML = '';
        items.forEach(function (label) {
          var li = document.createElement('li');
          li.textContent = label;
          els.kitList.appendChild(li);
        });
      }

      function render() {
        if (!currentConfig) return;

        if (els.weight) els.weight.textContent = currentConfig.gvm_weight || '';
        if (els.liftBadge) els.liftBadge.textContent = currentConfig.lift_badge || '';
        if (els.installBadge) els.installBadge.textContent = currentConfig.install_badge || '';
        if (els.vehicleText) els.vehicleText.textContent = currentConfig.vehicle_text || '';
        if (els.preRego) els.preRego.textContent = currentConfig.pre_rego || '';
        if (els.postRego) els.postRego.textContent = currentConfig.post_rego || '';
        if (els.description) els.description.textContent = currentConfig.description || '';

        var shock = optionAt('shocks', state.shocks);
        var leaf = optionAt('leafs', state.leafs);
        var heroImage = (shock && shock.image) ? shock.image : (currentConfig.hero_image || '');
        if (els.image && heroImage) {
          els.image.classList.add('is-swapping');
          window.setTimeout(function () {
            els.image.src = heroImage;
            els.image.alt = currentConfig.gvm_weight || '';
            els.image.classList.remove('is-swapping');
          }, 120);
        }

        groupNames.forEach(renderOptions);
        renderKitContents();

        if (els.sku) els.sku.textContent = computeSku();
        if (els.price) els.price.textContent = formatPrice(computePrice());

        if (els.summary) {
          var bits = [currentConfig.gvm_weight, currentConfig.lift_badge];
          if (shock) bits.push(shock.label);
          if (leaf) bits.push(leaf.label);
          els.summary.textContent = bits.filter(Boolean).join(' • ');
        }
      }

      function defaultIndexFor(list) {
        if (!list || list.length === 0) return null;
        for (var i = 0; i < list.length; i++) {
          if (list[i].recommended) return i;
        }
        return 0;
      }

      function loadTab(index) {
        var cfg = configs[index];
        if (!cfg) return;
        currentConfig = cfg;
        state = {
          shocks: defaultIndexFor(cfg.shocks),
          leafs: defaultIndexFor(cfg.leafs),
          ucas: null,
          airbags: null
        };
        render();
      }

      tabButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          tabButtons.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          loadTab(parseInt(btn.getAttribute('data-tab-index'), 10));
        });
      });

      if (els.enquire) {
        els.enquire.addEventListener('click', function () {
          var event = new CustomEvent('gvm:enquire', {
            bubbles: true,
            detail: { sku: computeSku(), price: computePrice() }
          });
          root.dispatchEvent(event);
        });
      }

      var activeIndex = 0;
      tabButtons.forEach(function (btn, i) {
        if (btn.classList.contains('is-active')) activeIndex = i;
      });
      loadTab(activeIndex);
    }

    document.querySelectorAll('.gvm-cfg').forEach(initGvmConfigurator);

    document.addEventListener('shopify:section:load', function (evt) {
      var root = evt.target.querySelector('.gvm-cfg');
      if (root) initGvmConfigurator(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-selector-2"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Cap year used for open-ended "+" ranges
  var MAX_YEAR = 2026;

  // Each variant uses start/end years. end = MAX_YEAR means "and newer".
  var vehicleData = {
    ram: {
      "1500 DS": { variants: [
        { start: 2013, end: 2018, handle: "ram-1500-ds-2013-2024" },
        { start: 2019, end: 2024, handle: "ram-1500-ds-2013-2024" }
      ]},
      "1500 DT": { variants: [
        { start: 2019, end: 2024, handle: "ram-1500-dt-2019-2024" },
        { start: 2025, end: MAX_YEAR, handle: "ram-1500-dt-2025" }
      ]},
      "1500 TRX": { variants: [
        { start: 2019, end: MAX_YEAR, handle: "ram-1500-trx-2019" }
      ]},
      "2500": { variants: [
        { start: 2013, end: 2018, handle: "ram-2500-2013-2018" },
        { start: 2019, end: 2024, handle: "ram-2500-2019-2024" },
        { start: 2025, end: MAX_YEAR, handle: "ram-2500-2025" }
      ]},
      "3500": { variants: [
        { start: 2013, end: 2018, handle: "ram-3500-2013-2018" },
        { start: 2019, end: 2024, handle: "ram-3500-2019-2024" },
        { start: 2025, end: MAX_YEAR, handle: "ram-3500-2025" }
      ]}
    },
    chevrolet: {
      "Silverado 1500": { variants: [
        { start: 2007, end: 2013, handle: "silverado-1500-2007-2013" },
        { start: 2014, end: 2018, handle: "silverado-1500-2014-2018" },
        { start: 2019, end: 2024, handle: "silverado-1500-2019-2024" }
      ]},
      "Silverado 1500 ZR2": { variants: [
        { start: 2022, end: MAX_YEAR, handle: "silverado-1500-zr2" }
      ]},
      "Silverado 2500": { variants: [
        { start: 2011, end: 2019, handle: "silverado-2500-2011-2019" },
        { start: 2020, end: 2023, handle: "silverado-2500-2020-2023" },
        { start: 2024, end: MAX_YEAR, handle: "silverado-2500-2024" }
      ]},
      "Silverado 3500": { variants: [
        { start: 2011, end: 2019, handle: "silverado-3500-2011-2019" },
        { start: 2020, end: 2023, handle: "silverado-3500-2020-2023" }
      ]}
    },
    ford: {
      "F-150": { variants: [
        { start: 2015, end: 2020, handle: "ford-f-150-2015-2020" },
        { start: 2021, end: MAX_YEAR, handle: "ford-f-150-2021" }
      ]},
      "F-250": { variants: [
        { start: 2009, end: 2014, handle: "ford-f-250-2009-2014" },
        { start: 2011, end: 2016, handle: "ford-f-250-2011-2016" },
        { start: 2023, end: MAX_YEAR, handle: "ford-f-250-2023" }
      ]},
      "F-350": { variants: [
        { start: 2008, end: 2010, handle: "ford-f-350-2008-2010" },
        { start: 2017, end: 2019, handle: "ford-f-350-2017-2019" },
        { start: 2020, end: 2022, handle: "ford-f-350-2020-2022" },
        { start: 2023, end: MAX_YEAR, handle: "ford-f-350-2023" }
      ]},
      "F-450": { variants: [
        { start: 2008, end: 2010, handle: "ford-f-450-2008-2010" },
        { start: 2011, end: 2016, handle: "ford-f-450-2011-2016" },
        { start: 2020, end: 2022, handle: "ford-f-450-2020-2022" },
        { start: 2023, end: MAX_YEAR, handle: "ford-f-450-2023" }
      ]},
      "Ranger": { variants: [
        { start: 2007, end: MAX_YEAR, handle: "ford-ranger" }
      ]}
    },
    gmc: {
      "Sierra 1500": { variants: [
        { start: 2007, end: 2013, handle: "gmc-1500-sierra-2007-2013" },
        { start: 2014, end: 2018, handle: "gmc-1500-sierra-2014-2018" },
        { start: 2019, end: 2024, handle: "gmc-1500-sierra-2019-2024" }
      ]},
      "Sierra 2500": { variants: [
        { start: 2011, end: 2019, handle: "gmc-2500-sierra-2011-2019" },
        { start: 2020, end: 2023, handle: "gmc-2500-sierra-2020" },
        { start: 2024, end: MAX_YEAR, handle: "gmc-2500-sierra-2024" }
      ]}
    },
    toyota: {
      "Tundra": { variants: [
        { start: 2007, end: 2015, handle: "toyota-tundra-2007-2015" },
        { start: 2016, end: 2021, handle: "toyota-tundra-2016-2021" },
        { start: 2022, end: 2024, handle: "toyota-tundra-2022-2024" }
      ]},
      "Hilux": { variants: [
        { start: 2007, end: MAX_YEAR, handle: "toyota-hilux" }
      ]}
    },
    jeep: {
      "Wrangler JK": { variants: [
        { start: 2007, end: 2018, handle: "jeep-wrangler-jk-2007-2018" }
      ]},
      "Wrangler JL": { variants: [
        { start: 2018, end: MAX_YEAR, handle: "jeep-wrangler-jl-2018" }
      ]},
      "Wrangler JT": { variants: [
        { start: 2020, end: MAX_YEAR, handle: "jeep-wrangler-jt-2020" }
      ]}
    }
  };

  function initForm(form) {
    if (!form || form.dataset.vbInit === "true") return;
    form.dataset.vbInit = "true";

    var makeSelect = form.querySelector("[data-vb-make]");
    var modelSelect = form.querySelector("[data-vb-model]");
    var yearSelect = form.querySelector("[data-vb-year]");
    var resetBtn = form.querySelector("[data-vb-reset]");

    if (!makeSelect || !modelSelect || !yearSelect) return;

    var modelLabel = modelSelect.getAttribute("data-label") || "Model";
    var yearLabel = yearSelect.getAttribute("data-label") || "Year Model";

    function resetSelect(select, label) {
      select.innerHTML = '<option value="">' + label + '</option>';
      select.disabled = true;
    }

    // Returns the collection handle for a given year, or null if no match.
    function handleForYear(variants, year) {
      for (var i = 0; i < variants.length; i++) {
        if (year >= variants[i].start && year <= variants[i].end) {
          return variants[i].handle;
        }
      }
      return null;
    }

    // Build a descending list of unique years covered by the model's variants.
    function yearsForModel(variants) {
      var set = {};
      variants.forEach(function (v) {
        for (var y = v.start; y <= v.end; y++) {
          set[y] = true;
        }
      });
      var years = Object.keys(set).map(Number);
      years.sort(function (a, b) { return b - a; }); // newest first
      return years;
    }

    makeSelect.addEventListener("change", function () {
      resetSelect(modelSelect, modelLabel);
      resetSelect(yearSelect, yearLabel);

      var make = this.value;
      if (!make || !vehicleData[make]) return;

      Object.keys(vehicleData[make]).forEach(function (model) {
        var opt = document.createElement("option");
        opt.value = model.toLowerCase().replace(/\s+/g, "-");
        opt.textContent = model;
        opt.setAttribute("data-model", model);
        modelSelect.appendChild(opt);
      });
      modelSelect.disabled = false;
    });

    modelSelect.addEventListener("change", function () {
      resetSelect(yearSelect, yearLabel);

      var make = makeSelect.value;
      var selectedOpt = modelSelect.options[modelSelect.selectedIndex];
      var modelKey = selectedOpt ? selectedOpt.getAttribute("data-model") : null;

      if (!make || !modelKey || !vehicleData[make][modelKey]) return;

      var variants = vehicleData[make][modelKey].variants;
      if (!variants || variants.length === 0) return;

      yearsForModel(variants).forEach(function (year) {
        var handle = handleForYear(variants, year);
        if (!handle) return;
        var opt = document.createElement("option");
        opt.value = handle;          // route straight to the range collection
        opt.textContent = year;      // display the individual year
        opt.setAttribute("data-year", year);
        yearSelect.appendChild(opt);
      });
      yearSelect.disabled = false;
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var make = makeSelect.value;
      var model = modelSelect.value;
      var handle = yearSelect.value;

      if (!make || !model || !handle) {
        alert("Please select Make, Model, and Year Model");
        return;
      }
      window.location.href = "/collections/" + handle;
    });

    if (resetBtn) {
      resetBtn.addEventListener("click", function () {
        makeSelect.value = "";
        resetSelect(modelSelect, modelLabel);
        resetSelect(yearSelect, yearLabel);
      });
    }
  }

  function initAll() {
    document.querySelectorAll("[data-vb-form]").forEach(initForm);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
